import React, {FC, useRef} from 'react';
import {FormControl, InputAdornment, InputBase} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import PlacesAutocompleteInputAdornmentEnd from './PlacesAutocompleteInputAdornmentEnd';
import PlacesAutocompleteMui from './PlacesAutocompleteMui';
import {PlacePrediction} from './interfaces';
import './style.css';
import {styled} from "@mui/material/styles";

const PlacesAutoSearchIcon = styled(SearchIcon)(() => ({
  fontSize: '2.5rem',
}));

const StyledSearchInputBase = styled(InputBase)(({theme}) => ({
  '& .MuiInputBase-input': {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    lineHeight: '1.75',
    letterSpacing: '0.00938em',
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '16px',
    },
  },
}));

interface PlacesAutocompleteInputMuiProps {
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  name: string;
  onCancelIconClick: () => void;
  onFiltersIconClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  selectedPacItem: PlacePrediction | undefined;
  handleClickPac: (pacItem: PlacePrediction) => void;
  handleSelectPac: (pacItem: PlacePrediction | undefined) => void;
  containerRef: React.RefObject<HTMLDivElement | null>;
  showPac: boolean;
  showFilters?: boolean;
  // Only a clear button at the end: no "Hit Enter" hint or filters toggle.
  compact?: boolean;
  autoFocus?: boolean;
  handleKeyUp?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

const PlacesAutocompleteInputMui: FC<PlacesAutocompleteInputMuiProps> = (props) => {
  const {
    onChange,
    value,
    name,
    onCancelIconClick,
    onFiltersIconClick,
    selectedPacItem,
    handleClickPac,
    handleSelectPac,
    containerRef,
    showPac,
    showFilters,
    compact,
    autoFocus,
    handleKeyUp,
  } = props;
  const inputRef = useRef<HTMLInputElement>(null);

  return <>
    <FormControl fullWidth>
      <StyledSearchInputBase type="text"
                 inputRef={inputRef}
                 name={name}
                 value={value}
                 onChange={onChange}
                 className='searchinput'
                 placeholder="Type a location"
                 startAdornment={<InputAdornment position="start">
                   <PlacesAutoSearchIcon  color={'primary'}/>
                 </InputAdornment>}
                 endAdornment={<PlacesAutocompleteInputAdornmentEnd searchValue={value}
                                                                    showFilters={showFilters}
                                                                    onCancelIconClick={onCancelIconClick}
                                                                    onFiltersIconClick={onFiltersIconClick}
                                                                    compact={compact}
                 />}
                 autoComplete={'off'}
                 autoFocus={autoFocus}
                 onKeyUp={handleKeyUp}
      />
    </FormControl>
    {
      showPac && <PlacesAutocompleteMui inputRef={inputRef}
                                        inputValue={value}
                                        containerRef={containerRef}

                                        onClickPac={handleClickPac}
                                        handleSelectPac={handleSelectPac}
                                        selectedPacItem={selectedPacItem}
      />
    }
  </>
}


export default PlacesAutocompleteInputMui;
